import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { isValidDateOnly } from '@/lib/analyticsWindow';

const PRESETS = [
  { value: '1', labelKey: 'last1Day', fallback: 'Last 1 day' },
  { value: '7', labelKey: 'last7Days', fallback: 'Last 7 days' },
  { value: '14', labelKey: 'last14Days', fallback: 'Last 14 days' },
  { value: '30', labelKey: 'last30Days', fallback: 'Last 30 days' },
  { value: '90', labelKey: 'last90Days', fallback: 'Last 90 days' },
];

export default function AnalyticsDateRangeControl({
  selectValue,
  onSelectValue,
  draftFrom,
  draftTo,
  onDraftFrom,
  onDraftTo,
  onApplyCustom,
  t,
}) {
  const custom = selectValue === 'custom';
  const bothValid = isValidDateOnly(draftFrom) && isValidDateOnly(draftTo);
  const label = (key, fallback) => (t && t(key)) || fallback;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select value={selectValue} onValueChange={onSelectValue}>
        <SelectTrigger className="w-full sm:w-44">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PRESETS.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {label(p.labelKey, p.fallback)}
            </SelectItem>
          ))}
          <SelectItem value="custom">Custom range</SelectItem>
        </SelectContent>
      </Select>
      {custom ? (
        <>
          <Input
            type="date"
            value={draftFrom}
            onChange={(e) => onDraftFrom(e.target.value)}
            aria-label="Start date"
            className="w-[9.5rem]"
          />
          <Input
            type="date"
            value={draftTo}
            onChange={(e) => onDraftTo(e.target.value)}
            aria-label="End date"
            className="w-[9.5rem]"
          />
          <Button
            type="button"
            variant="outline"
            disabled={!bothValid}
            onClick={onApplyCustom}
          >
            Apply
          </Button>
        </>
      ) : null}
    </div>
  );
}
